import { useQueryClient } from 'react-query'

const useInvalidateQueries = () => {
  const queryClient = useQueryClient()

  const invalidateQueries = (queries = []) => {
    if (typeof queries === 'string') {
      return queryClient.invalidateQueries(queries)
    }

    return queries.map(async (query) => await queryClient.invalidateQueries(query))
  }

  return {
    invalidateQueries,
  }
}

export default useInvalidateQueries
